<div class="container pt-0 pt-md-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-6 d-flex mx-auto mt-4">
      <img
        src="{{ '/images/happy-wholesalers.png' | blobstorage }}"
        alt="Happy members"
        class="w-100 h-100 object-fit-cover"
      />
    </div>

    <div class="col-md-6 text-center text-md-start">
      <div class="row">
        <h2 class="fw-bold mb-3">
          {{ "Acuerdo de clientes mayoristas" | translate }}
        </h2>
      </div>
      <div class="row">
        <span class="mb-4 fs-terms">
          {{
            "¿Quieres empezar ya? Consulta los Términos y Condiciones y súmate al programa." | translate
          }}
        </span>
      </div>
      <div class="row">
        <a class="btn btn-termns rounded-pill m-auto" target="_blank"
           href="{{ termsConditionsPDF | blobstorage}}">
            {{ "Términos y Condiciones." | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
